<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1rDyFy/tc-custom/9781035812356.jpg?1718183630413" alt="This image is the cover for the book The Neighbour at Number 18 - Stand by Me"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Neighbour at Number 18 - Stand by Me
      </h1>
      <p class="bookDescription body article font2">
        <p>Two single mothers, Brenda and Maureen established friendships when shopping in the city one day. As normal London families, they shared ideas and helped each other out. They both had daughters who automatically became friends too. Events enfold when Tyler the nephew of Maureen began to blackmail his cousin Emilia, Maureen’s daughter leading her to sexually groom Maria for Tyler, Brenda’s daughter. <br/>Maureen suffered depression and was sectioned upon hearing what her nephew had done, Emilia got married early and left for Spain. <br/>Maria pursued her education and became a lawyer, but her experience with Tyler scared her emotions; could she love any man? This novel talks about family life and how circumstances change with time. Unexpected illness etc. Find out how The Neighbour at Number 18 got involved.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Hawa Crickmore
      </h2>
      
      <p class="authorDescription body article">Hawa Crickmore was born in Ghana in 1958. She has a Bachelor of Education in Management and has taught at various levels of education. She has also studied at Middlesex University in London and obtained a master’s degree in health and social care, which motivated her to establish a care service and training company with her husband, Ken. She enjoys the art of writing and has successfully published her first novel, Across the Ocean. The Neighbour at Number 18 is her second novel. Hawa has two sons, two daughters, two stepdaughters and three grandchildren. She currently resides with her husband in Kent in the United Kingdom.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?820a9190